// Cart form
const authenticityToken = () => {
  let authenticity_token = $('meta[name="csrf-token"]').attr('content');
  if (authenticity_token == undefined || authenticity_token == "") {
    authenticity_token = $('[name="authenticity_token"]').attr('value');
  };

  return authenticity_token
}

$(document).ready(function() {
  document.querySelectorAll('.form-input-cart').forEach(el => {
    const input        = el.querySelector('.form-input-cart-quantity')
    const plusButton   = el.querySelector('.plus')
    const minusButton  = el.querySelector('.minus')
    const max          = parseInt(input.getAttribute('max'))
    const min          = parseInt(input.getAttribute('min'))

    const verifyValueButton = val => {
      if (val < min) {
        input.value = min

        let formInput = document.querySelector('#form-cart-input-liquid')
        if (formInput != null) { formInput.value = input.value }
      };
      if (val >= max) {
        plusButton.classList.add('disabled')
        plusButton.classList.add('text-muted')
      } else {
        plusButton.classList.remove('disabled')
        plusButton.classList.remove('text-muted')
      }
      if (val <= 1) {
        minusButton.classList.add('disabled')
        minusButton.classList.add('text-muted')
      } else {
        minusButton.classList.remove('disabled')
        minusButton.classList.remove('text-muted')
      }
    }

    const updateDescription = (el, qty) => {
      const itemableId           = el.dataset['itemableId']
      const itemableType         = el.dataset['itemableType']
      const currency             = el.dataset['currency']
      const itemableCreditAmount = parseFloat(el.dataset['itemableCreditAmount']) || 0

      if (itemableType === 'CreditPackage') {
        const description = document.querySelector(`#description-${itemableId}`)
        if (description != null) {
          var totalCreditAmount   = parseInt(itemableCreditAmount * qty)
          description.textContent =`Credit Amount ${formatMoney(totalCreditAmount, currency)}`
        }
      }
    }

    input.addEventListener('keypress', e => {
      const val = parseInt(e.currentTarget.value)
      if (val >= max) {
        e.preventDefault()
        e.stopPropagation()
      }
      verifyValueButton(val)
      updateDescription(el, val)
    })

    input.addEventListener('change', e => {
      let val = parseInt(e.currentTarget.value)
      if (val >= max) {
        e.currentTarget.value = max;
        val = max;
      }
      verifyValueButton(val)
      updateDescription(el, val)
      var request_url = $(e.currentTarget).data('url');
      var current_qty = parseInt(val);

      if (current_qty >= 1 && request_url != undefined) {
        $.ajax({
          beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', authenticityToken())},
          type: "POST",
          url: request_url,
          data: {
            qty: current_qty
          }
        })
      }
    })

    plusButton.addEventListener('click', e => {
      e.stopPropagation()
      e.preventDefault()
      const val = parseInt(input.value)

      if (val >= max) {
        return false
      }
      input.value = val + 1
      input.dispatchEvent(new Event('change'))
      verifyValueButton(parseInt(input.value))
      updateDescription(el, parseInt(input.value))
    })

    minusButton.addEventListener('click', e => {
      e.stopPropagation()
      e.preventDefault()
      const val = parseInt(input.value)
      if (val > 1) {
        input.value = val - 1
        input.dispatchEvent(new Event('change'))
      }

      verifyValueButton(parseInt(input.value))
      updateDescription(el, parseInt(input.value))
    })

    verifyValueButton(parseInt(input.value))
    updateDescription(el, parseInt(input.value))
  })

  $('.btn-remove-cart-item').each(function(_idx, elm) {
    $(elm).removeClass('disabled')
  })
})
